import Command from '../Command';

class StopStreamingCommand extends Command {
	constructor(sender, recipient) {
		super(Command.STOP_STREAMING, sender, recipient);
	}
}

export default StopStreamingCommand;
